import store, { constants } from '../../store';

class User {
  static get() {
    if (this.instance instanceof User) {
      return this.instance;
    }
    
    this.instance = new User();
    
    return this.instance;
  } 
  
  constructor() {
    this.data = {
      cookie: store.get(constants.keys.YOLA_COOKIE)
    };
  }
  
  isAuthenticated() {
    return Boolean(this.data.cookie);
  }
}

export default User;
